export const initialAbility = [
  {
    action: 'API_B2B_USER',
    subject: 'AccessBothUser',
  },
]

export const _ = undefined
